import layoutSo from "stores/layout";
import userSo, { LOGIN_TYPE } from "stores/user";
import { BuildKeycloak, GetKeycloak } from "./keycloak";
import { enableMocking } from "./msw";
import { User } from "types/User";
import farmSo from "stores/farm";

const isPLC = import.meta.env.VITE_TARGET == "plc"



window.addEventListener("load", async (event) => StartSession())
window.addEventListener("beforeunload", async (event) => EndSession())
window.onerror = (message, url, line, col, error) => {
	//	logSo.addError(error)
}
window.addEventListener('online', function () {
	console.log("Sei tornato online!");
});
window.addEventListener('offline', function () {
	console.log("Sei andato offline!");
});


export async function StartSession() {

	// solo se è in dev
	await enableMocking()

	/** recupero i dati del OS */
	try {
		await userSo.fetchOSConfig()
	} catch (error) {
		console.log("OS CONFIG : non disponibile")
	}

	// se sono in target GPT non faccio il login
	// i dati "config" provendono dai valori di default presi da .env
	if (userSo.noAuth()) {
		layoutSo.setSysteReady(true)
		return
	}

	// effettuo l'auto-login
	try {
		await autoLogin()
	} catch (error) {
		console.error("Errore durante l'autologin", error)
	} finally {
		layoutSo.setSysteReady(true)
	}
}

export async function EndSession() {
}


/**
 * Effettuo il login iniziale, provando prima con il sistema legacy e poi con Keycloak (se abilitato)
 */
async function autoLogin() {

	// provo a recuperare col sistema legacy
	if (!isPLC) await userSo.fetchLegacy()

	// se c'e' lo user allora ha avuto successo
	if (userSo.isLogged()) {
		userSo.setLoginType(LOGIN_TYPE.LEGACY)
		return
	}

	// se non è abilitato Keycloak allora esco
	if (!userSo.state.config.sso.enabled) return
	BuildKeycloak(userSo.state.config.sso)
	if (!GetKeycloak()) {
		console.error("Keycloak non inizializzato correttamente")
		return
	}

	const keycloakOnLoad = isPLC ? "login-required" : "check-sso"

	// In PLC il login SSO e' obbligatorio: se non esiste una sessione attiva,
	// Keycloak deve redirigere subito alla sua pagina di autenticazione.
	const authenticated = await GetKeycloak().init({
		onLoad: keycloakOnLoad,
		pkceMethod: 'S256',
		checkLoginIframe: false,
	})
	console.log("Authenticated with Keycloak", authenticated)

	// se sono autenticato con Keycloak allora recupero i dati dell'utente
	if (GetKeycloak().authenticated && GetKeycloak().token) {
		// // [II] ricavo i dati dell'utente. ricordarsi di settare il ROLE "view-profile" in Keycloak per farlo funzionare
		// try {
		// 	const user = await GetKeycloak().loadUserProfile();
		// 	console.log( user)
		// } catch (error) {
		// 	console.error("Errore durante il recupero del profilo utente da Keycloak", error)
		// }

		// se siamo in PLC-CONSOLE ricavo i dati dal JWT
		if (isPLC) {
			const jwtParsed = GetKeycloak().tokenParsed as any
			// const role = jwtParsed.realm_access?.roles?.includes("admin") ? "admin"
			// 	: jwtParsed.realm_access?.roles?.includes("user") ? "user"
			// 		: "reader"
			//const roles = ["plc:reader", "plc:operator", "plc:admin"]
			const rolesProp:any = Object.entries(jwtParsed?.resource_access ?? {}).find(([key, value]) => key.startsWith("zero-edge-"))?.[1] ?? {}
			const jwtRoles:string[] = rolesProp?.roles ?? []
			const role = jwtRoles.some(r => r === "plc:admin")
				? "admin"
				: jwtRoles.some(r => r === "plc:operator") ? "user" : "reader"
			const debugEnabled = jwtParsed.realm_access?.roles?.includes("debug") || false
			const user: User = {
				id: jwtParsed.sub,
				debugEnabled,
				hasPlcAccess: true,
				forceEnabledTwoFa: false,
				email: jwtParsed.email,
				name: jwtParsed.name,
				role,
			}
			userSo.setCurrent(user)
			// altrimenti recupero i dati dell'utente con il sistema legacy (REST)
		} else {
			await userSo.fetchCurrent()
		}

		// imposto il tipo di login
		userSo.setLoginType(LOGIN_TYPE.KEYCLOAK)
	}
}
